import http from '../_http_v2';

const policy = {
  //default
  summary: (m) => { return http.get(`console/webcastle/policy`, m); },  //cmd : summary.i18n
  list: (m) => { return http.post(`console/webcastle/policy/list`, m); },
  detail: (m) => { return http.get(`console/webcastle/policy/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/webcastle/policy`, m); },
  update: (m) => { return http.put(`console/webcastle/policy`, m); },
  delete: (m) => { return http.delete(`console/webcastle/policy/${m.id}`); },

  //other
  latest: (m) => { return http.get(`console/webcastle/policy/latest`, m); },
  template: (m) => { return http.get(`console/webcastle/policy/template`, m); },
  version: (m) => { return http.get(`console/webcastle/policy/version`, m); },
}

export default policy